app.controller("ChangePasswordController", ["$scope", "$state", "$http", "$uibModal", "AuthService", "user", "$uibModalInstance", "toastr",
    function ($scope, $state, $http, $uibModal, AuthService, user, $uibModalInstance, toastr) {
        $scope.newPassword = "";
        $scope.repeatNewPassword = "";
        $scope.user = user;

        $scope.changePassword = function () {
            if ($scope.newPassword && $scope.repeatNewPassword) {
                if ($scope.newPassword === $scope.repeatNewPassword) {
                    AuthService.updatePassword({
                        user: $scope.user,
                        password: $scope.newPassword
                    }).then(function () {
                        toastr.success('პაროლი შეცვლილია');
                        $uibModalInstance.close()
                    });
                } else toastr.error('', 'გთხოვთ სწორად გაიმეოროთ ახალი პაროლი');
            } else toastr.error('', 'გთხოვთ შეავსოთ ყველა ველი');
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);